import React from 'react';
import './index.css';

const icons = {
  strategy: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M14.5 9.5L13 13l-3.5 1.5L11 11z" />
    </svg>
  ),
  cloud: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 18h10a4 4 0 0 0 .5-7.97A5.5 5.5 0 0 0 7.1 9.2 4 4 0 0 0 7 18z" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3.5l6.5 2.7v5.3c0 4.2-2.8 7-6.5 8.5-3.7-1.5-6.5-4.3-6.5-8.5V6.2L12 3.5z" />
      <path d="M9.3 12l1.9 1.9 3.5-3.9" />
    </svg>
  ),
  support: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4.5 13a7.5 7.5 0 0 1 15 0" />
      <rect x="3.2" y="13" width="4" height="6" rx="1.5" />
      <rect x="16.8" y="13" width="4" height="6" rx="1.5" />
    </svg>
  ),
  code: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8.5 8L4.5 12l4 4" />
      <path d="M15.5 8l4 4-4 4" />
    </svg>
  ),
  transform: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 12a8 8 0 0 1 13.5-5.7" />
      <path d="M20 12a8 8 0 0 1-13.5 5.7" />
      <path d="M17.5 2.7v3.6h-3.6" />
      <path d="M6.5 21.3v-3.6h3.6" />
    </svg>
  ),
  compass: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.5 8.5 0 0 1-8.6 8.5H4l2.9-3.8a8.5 8.5 0 1 1 14.1-4.7z" />
      <path d="M9.2 12l1.8 1.8 3.8-3.8" />
    </svg>
  ),
  scale: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3v18" />
      <path d="M5 21h14" />
      <path d="M5 7h14" />
      <path d="M5 7l-3 6a3.2 3.2 0 0 0 6 0z" />
      <path d="M19 7l-3 6a3.2 3.2 0 0 0 6 0z" />
    </svg>
  ),
  user: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="3.8" />
      <path d="M4.5 20c0-4 3.5-6.5 7.5-6.5s7.5 2.5 7.5 6.5" />
    </svg>
  ),
};

const services = [
  {
    icon: 'compass',
    title: 'IT Strategy & Consulting',
    description:
      'Technology roadmaps, audits, and vendor-neutral advice that align IT with where your business is actually headed.',
  },
  {
    icon: 'cloud',
    title: 'Cloud & Infrastructure',
    description:
      'Migration, architecture, and ongoing management of the cloud and on-prem systems your business runs on.',
  },
  {
    icon: 'shield',
    title: 'Cybersecurity',
    description:
      'Risk assessments, hardening, and practical security measures sized to your business, not a Fortune 500.',
  },
  {
    icon: 'support',
    title: 'Managed IT Support',
    description:
      'Day-to-day monitoring and support so systems stay reliable and issues get fixed before they become problems.',
  },
  {
    icon: 'code',
    title: 'Custom Software & Integrations',
    description:
      'Bespoke tools and integrations that connect the systems you already use instead of forcing a rebuild.',
  },
  {
    icon: 'transform',
    title: 'Digital Transformation',
    description:
      'Modernizing legacy processes and systems in stages that fit your team, budget, and timeline.',
  },
];

const values = [
  {
    icon: 'strategy',
    title: 'Straight advice',
    description: 'Recommendations based on what your business needs, not what pads an invoice.',
  },
  {
    icon: 'scale',
    title: 'Vendor-neutral',
    description: 'No reseller agreements steering the conversation — just the right tool for the job.',
  },
  {
    icon: 'user',
    title: 'Direct access',
    description: 'You work with a senior consultant end to end, not a rotating support queue.',
  },
];

const badges = ['Vendor-neutral', 'Senior-led', 'Plain English'];

function App() {
  const year = new Date().getFullYear();

  return (
    <div className="site">
      <header className="nav">
        <div className="container nav-inner">
          <img
            src="/logoandname_black.jpeg"
            alt="Jotech IT Consulting"
            className="nav-logo"
          />
          <nav className="nav-links">
            <a href="#services">Services</a>
            <a href="#about">About</a>
            <a href="#contact">Contact</a>
          </nav>
          <a href="#contact" className="btn btn-primary btn-sm">
            Get in touch
          </a>
        </div>
      </header>

      <main>
        <section className="hero">
          <div className="hero-glow hero-glow-a" aria-hidden="true" />
          <div className="hero-glow hero-glow-b" aria-hidden="true" />
          <div className="container hero-inner">
            <p className="kicker">
              <span className="kicker-dot" />
              IT Consulting
            </p>
            <h1>
              Practical IT advice, <span className="highlight">zero jargon.</span>
            </h1>
            <p className="hero-sub">
              Jotech helps small and mid-sized businesses plan, secure, and run their
              technology — so you can get back to running the business.
            </p>
            <div className="hero-actions">
              <a href="#contact" className="btn btn-primary btn-lg">
                Book a free consultation
              </a>
              <a href="#services" className="btn btn-outline">
                See what we do
              </a>
            </div>
            <div className="hero-badges">
              {badges.map((badge) => (
                <span className="hero-badge" key={badge}>
                  <span className="hero-badge-dot" />
                  {badge}
                </span>
              ))}
            </div>
          </div>
        </section>

        <section id="services" className="services">
          <div className="container">
            <p className="eyebrow">
              <span className="kicker-dot" />
              Services
            </p>
            <h2>What we do</h2>
            <p className="section-sub">
              Focused IT consulting services, tailored to how your business actually works.
            </p>
            <div className="grid services-grid">
              {services.map((service) => (
                <div className="card" key={service.title}>
                  <span className="icon-badge">{icons[service.icon]}</span>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="about" className="about">
          <div className="container about-inner">
            <div className="about-text">
              <p className="eyebrow">
                <span className="kicker-dot" />
                About
              </p>
              <h2>About Jotech</h2>
              <p>
                Jotech is an independent IT consulting practice built for small and
                mid-sized businesses that need real technology guidance — not a sales
                pitch dressed up as advice.
              </p>
              <p>
                We work directly with owners and teams to make sense of cloud, security,
                and infrastructure decisions, then help implement them properly and
                support them over time.
              </p>
            </div>
            <div className="about-panel">
              <img src="/logo_black.jpeg" alt="" className="about-logo" aria-hidden="true" />
            </div>
          </div>
        </section>

        <section className="values">
          <div className="container">
            <p className="eyebrow">
              <span className="kicker-dot" />
              Why Jotech
            </p>
            <h2>How we work</h2>
            <div className="grid values-grid">
              {values.map((value) => (
                <div className="value" key={value.title}>
                  <span className="value-icon">{icons[value.icon]}</span>
                  <h3>{value.title}</h3>
                  <p>{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="contact">
          <div className="hero-glow hero-glow-a" aria-hidden="true" />
          <div className="container contact-inner">
            <h2>Let&apos;s talk about your technology</h2>
            <p>
              Tell us what you&apos;re working with and where it&apos;s falling short.
              We&apos;ll reply with practical next steps, not a proposal template.
            </p>
            <a href="mailto:jonas@jotech.be" className="btn btn-primary btn-lg">
              Email Jotech
            </a>
            <p className="contact-email">jonas@jotech.be</p>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container footer-inner">
          <img
            src="/logoandname_white.jpeg"
            alt="Jotech IT Consulting"
            className="footer-logo"
          />
          <nav className="footer-links">
            <a href="#services">Services</a>
            <a href="#about">About</a>
            <a href="#contact">Contact</a>
          </nav>
          <p className="footer-copy">© {year} Jotech IT Consulting. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
